var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"open":_vm.selectionNeeded,"persistent":true}},[_c('AccountSelector',{staticClass:"bg-white p-8 rounded-sm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }